import { id } from 'date-fns/locale';
import gql from 'graphql-tag';

export const gqlGetQuery = gql`
  query getAlarms($limit: Int, $offset: Int, $order: String, $where: String) {
    getAlarms(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        message
        link
        alarmTypeId
        alarmType {
          id
          name
          description
        }
        alarmDate
        idocId
        idoc {
          id
          identificationDocument
        }
        collectorId
        collector {
          id
          name
          isApproved
        }
        vehicleId
        vehicle {
          id
          isApproved
          plateNumber
        }
        driverId
        driver {
          id
          name
          isApproved
        }
        wastereceptionpointId
        wastereceptionpoint {
          id
          name
          isApproved
        }
        isFixed
        isActive
        firstDate
        lastDate
        firstUser
        lastUser
      }
      recordCount
    }
  }
`;

export const gqlAddAlarm = gql`
  mutation addAlarm($data: AlarmInput) {
    addAlarm(data: $data) {
      id
    }
  }
`;
